import { createContext } from 'react';



export const GridContext = createContext({
  gridData: null,
})